import { liveStats, STATS_TYPES, AGGREGATION_LEVELS } from '@/mqtt/liveStats'

function answerCountPerAnswerValueKey(activityId, questionId, version, answerValue) {
  return `${activityId}_${questionId}_${version}_${answerValue}`
}

function answerCountPerActivityKey(activityId, version) {
  return `${activityId}_${version}`
}

const _state = {
  [`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`]: {},
  [`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`]: {},
  [`${STATS_TYPES.AVERAGE_SCORE}_${AGGREGATION_LEVELS.PER_QUESTION}`]: {},
  [`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`]: {},
  [`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`]: {},
  [`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`]: {},
  [`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`]: {},
}

function averageScorePerQuestionKey(activityId, version, questionId) {
  return `${activityId}_${version}_${questionId}`
}

const mutations = {
  [`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`](state, {
    identifier, questionId, version, answerValue, answerCount,
  }) {
    state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`] = {
      ...state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`],
      [answerCountPerAnswerValueKey(identifier, questionId, version, answerValue)]: answerCount,
    }
  },
  [`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`](state, {
    identifier, version, answerCount,
  }) {
    state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`] = {
      ...state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`],
      [answerCountPerActivityKey(identifier, version)]: Number(answerCount),
    }
  },
  [`${STATS_TYPES.AVERAGE_SCORE}_${AGGREGATION_LEVELS.PER_QUESTION}`](state, {
    identifier, version, questionId, averageScore,
  }) {
    state[`${STATS_TYPES.AVERAGE_SCORE}_${AGGREGATION_LEVELS.PER_QUESTION}`] = {
      ...state[`${STATS_TYPES.AVERAGE_SCORE}_${AGGREGATION_LEVELS.PER_QUESTION}`],
      [averageScorePerQuestionKey(identifier, version, questionId)]: averageScore,
    }
  },
  [`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`](state, {
    identifier, questionId, version, answerValue, answerCount,
  }) {
    state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`] = {
      ...state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`],
      [answerCountPerAnswerValueKey(identifier, questionId, version, answerValue)]: Number(answerCount),
    }
  },
  [`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`](state, {
    identifier, questionId, version, answerValue, answerCount,
  }) {
    state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`] = {
      ...state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`],
      [answerCountPerAnswerValueKey(identifier, questionId, version, answerValue)]: Number(answerCount),
    }
  },
  [`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`](state, {
    identifier, version, answerCount,
  }) {
    state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`] = {
      ...state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`],
      [answerCountPerActivityKey(identifier, version)]: Number(answerCount),
    }
  },
  [`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`](state, {
    identifier, version, answerCount,
  }) {
    state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`] = {
      ...state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`],
      [answerCountPerActivityKey(identifier, version)]: Number(answerCount),
    }
  },
}

const actions = {
  subscribeStatsAction({ commit }, payload) {
    liveStats.subscribeStats(payload, (_, __, statsUpdate) => {
      commit(statsUpdate.type, statsUpdate)
      if (payload.callback) {
        payload.callback(statsUpdate)
      }
    })
  },
}

const getters = {
  answerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`][answerCountPerAnswerValueKey(activityId, questionId, version, answerValue)]
    }
  },
  answerCountPerActivity(state) {
    return (activityId, version) => {
      return state[`${STATS_TYPES.ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`][answerCountPerActivityKey(activityId, version)]
    }
  },
  averageScorePerQuestion(state) {
    return (activityId, version, questionId) => {
      return state[`${STATS_TYPES.AVERAGE_SCORE}_${AGGREGATION_LEVELS.PER_QUESTION}`][averageScorePerQuestionKey(activityId, version, questionId)]
    }
  },
  correctAnswerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`][answerCountPerAnswerValueKey(activityId, questionId, version, answerValue)]
    }
  },
  incorrectAnswerCountPerAnswerValue(state) {
    return (activityId, questionId, version, answerValue) => {
      return state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ANSWER_VALUE}`][answerCountPerAnswerValueKey(activityId, questionId, version, answerValue)]
    }
  },
  correctAnswerCountPerActivity(state) {
    return (activityId, version) => {
      return state[`${STATS_TYPES.CORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`][answerCountPerActivityKey(activityId, version)]
    }
  },
  incorrectAnswerCountPerActivity(state) {
    return (activityId, version) => {
      return state[`${STATS_TYPES.INCORRECT_ANSWER_COUNT}_${AGGREGATION_LEVELS.PER_ACTIVITY}`][answerCountPerActivityKey(activityId, version)]
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
